import { createSlice } from '@reduxjs/toolkit';

interface SliceStockPersonalTotalState {
	textSeach: string;
	granFamiliaItem: { label: string, value: string, dataComplete: { label: string, value: string } }
};

const initialState: SliceStockPersonalTotalState = {
	textSeach: '',
	granFamiliaItem: { label: '', value: '', dataComplete: { label: '', value: '' } }
};

const stockPersonalTotalSlice = createSlice({
	name: 'stockPersonalTotalSlice',
	initialState,
	reducers: {
		changeTextSeach: (state, action) => {
			return {
				...state,
				textSeach: action.payload,
			};
		},
		changeGranFamiliaItem: (state, action) => {
			return {
				...state,
				granFamiliaItem: action.payload,
			};
		},
	},
});


export const {
	changeTextSeach,
	changeGranFamiliaItem,
} = stockPersonalTotalSlice.actions;

export default stockPersonalTotalSlice.reducer;